import React, { Component } from 'react';
import { Button, Modal, Form, Col, ButtonGroup, ToggleButton, Alert } from 'react-bootstrap';

class CreateCustomerUserModal extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            user: {
                firstName: '', lastName: '', emailAddress: '', phoneNumber: { number: '', phoneType: null }, userType: 1, accountId: 0
            },
            errors: { firstName: '', lastName: '', emailAddress: '', number: '', phoneType: '', general: '' },
            validState: false
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.handleUserIntInput = this.handleUserIntInput.bind(this);
        this.handlePhoneInput = this.handlePhoneInput.bind(this);
        this.handlePhoneIntInput = this.handlePhoneIntInput.bind(this);
        this.saveModel = this.saveModel.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateFieldHandler = this.validateFieldHandler.bind(this);
        this.handleRadioInput = this.handleRadioInput.bind(this);
        this.validateAll = this.validateAll.bind(this);
    }

    componentDidMount() {
        var user = this.props.model; // I pass the account id in the model
        this.setState({ user: user });

    }

    async saveModel() {
        if (this.validateAll()) {

        }
        var result = await this.props.saveModel(this.state.user);
        if (result != undefined && !result.result) {
            var partialState = this.state.errors;
            partialState.general = result.message;
            this.setState({ errors: partialState });
        }
    }

    validateAll(hideErrors) {
        var obj = this.state.user;
        var valid = true;
        for (const [key, value] of Object.entries(obj)) {
            valid = valid && this.validateField(key, value, hideErrors);
        }
        this.setState({validState: !valid})
        return valid;
    }
    validateFieldHandler(event) {
        const { name, value } = event.target;
        this.validateField(name, value, true);
    }

    validateField(name, value, hideErrors) {
        const validEmailRegex =
            RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

        var validPhone = RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i);

        
        let errors = this.state.errors;

        var valid = true;

        switch (name) {
            case 'firstName':
                errors.firstName =
                    value < 1
                        ? 'First Name is not valid!'
                        : '';
                valid = false;
                break;
            case 'lastName':
                errors.lastName =
                    value < 1
                        ? 'Last Name is not valid!'
                        : '';
                valid = false;
                break;
            case 'emailAddress':
                errors.emailAddress =
                    validEmailRegex.test(value)
                        ? ''
                        : 'Email is not valid!';
                valid = false;
                break;
            case 'number':
                var partialState = this.state.user;
                if (validPhone.test(value)) {
                    
                    partialState.phoneNumber.number =
                        partialState.phoneNumber.number.replace(validPhone, "($1) $2-$3");

                    this.setState({ user: partialState });
                    errors.number = '';
                } else {
                    errors.number = 'Number is not valid!';
                }
                valid = false;
                break;
            case 'phoneType':
                errors.phoneType =
                    value == 1 || value == 2
                        ? '' : 'Invalid phone type';
                valid = false;
                break;
            default:
                break;
        }

        this.setState({ errors }, () => { return valid })
    }

    handleUserInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var partialState = this.state.user;
        partialState[name] = value;
        this.setState({ user: partialState });
    }

    handlePhoneInput(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var partialState = this.state.user;
        if (partialState.phoneNumber === undefined || partialState.phoneNumber === null) {
            partialState["phoneNumber"] = { number: '', phoneType: null };
        }
        partialState.phoneNumber[name] = value;
        this.setState({ user: partialState });
    }

    handleUserIntInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = parseInt(target.value);
        const name = target.name;
        var partialState = this.state.user;
        partialState[name] = value;
        this.setState({ user: partialState });
    }
    handlePhoneIntInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = parseInt(target.value);
        const name = target.name;
        var partialState = this.state.user;
        partialState.phoneNumber[name] = value;
        this.setState({ user: partialState });
    }

    handleRadioInput(name, value) {
        var partialState = this.state.user;
        partialState[name] = value;
        this.setState({ user: partialState });
    }

    render() {
        return (
            <>
                <Modal.Header>Edit Contact</Modal.Header>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} lg="6" md="12">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control placeholder="Enter first name" name="firstName" id="firstName"
                                value={this.state.user.firstName}
                                onChange={this.handleUserInput}
                                onBlur={this.validateFieldHandler}
                            />
                            <small id="firstNameWarning" className="form-text text-danger" style={this.state.errors.firstName != '' ? null : { "display": "none" }}><b>{this.state.errors.firstName}</b></small>
                        </Form.Group>
                        <Form.Group as={Col} lg="6" md="12">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control placeholder="Enter last name" name="lastName" id="lastName"
                                value={this.state.user.lastName}
                                onChange={this.handleUserInput}
                                onBlur={this.validateFieldHandler}
                            />
                            <small id="lastNameWarning" className="form-text text-danger" style={this.state.errors.lastName != '' ? null : { "display": "none" }}><b>{this.state.errors.lastName}</b></small>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} lg="12" md="12">
                            <Form.Label>State</Form.Label><br/>
                            <ButtonGroup toggle>
                                <ToggleButton
                                    type="radio"
                                    variant="secondary"
                                    name="state"
                                    value={100}
                                    checked={this.state.user.state === 100}
                                    onChange={(e) => this.handleRadioInput("state", parseInt(e.currentTarget.value))}
                                >
                                    Active
                                    </ToggleButton>
                                <ToggleButton
                                    type="radio"
                                    variant="secondary"
                                    name="state"
                                    value={-50}
                                    checked={this.state.user.state === -50}
                                    onChange={(e) => this.handleRadioInput("state", parseInt(e.currentTarget.value))}
                                >
                                    Suspended
                                    </ToggleButton>
                                <ToggleButton
                                    type="radio"
                                    variant="secondary"
                                    name="state"
                                    value={-100}
                                    checked={this.state.user.state === -100}
                                    onChange={(e) => this.handleRadioInput("state", parseInt(e.currentTarget.value))}
                                >
                                    Deleted
                                </ToggleButton>
                            </ButtonGroup>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} lg="12" md="12">
                            <Form.Label>Email Address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email address" name="emailAddress" id="emailAddress"
                                value={this.state.user.emailAddress}
                                onChange={this.handleUserInput}
                                onBlur={this.validateFieldHandler} />
                            <small id="emailAddressWarning" className="form-text text-danger" style={this.state.errors.emailAddress != '' ? null : { "display": "none" }}><b>{this.state.errors.emailAddress}</b></small>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} lg="6" md="12">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control type="email" placeholder="Enter phone number" name="number" id="number"
                                value={this.state.user.phoneNumber?.number}
                                onChange={this.handlePhoneInput}
                                onBlur={this.validateFieldHandler}
                            />
                            <small id="phoneNumberWarning" className="form-text text-danger" style={this.state.errors.number != '' ? null : { "display": "none" }}><b>{this.state.errors.number}</b></small>
                        </Form.Group>
                        <Form.Group as={Col} lg="6" md="12">
                            <Form.Label>Phone Type</Form.Label>
                            <Form.Control as="select" name="phoneType" id="phoneType"
                                value={this.state.user.phoneNumber?.phoneType}
                                onChange={this.handlePhoneIntInput}
                                onBlur={this.validateFieldHandler}
                            >
                                <option value={null}>Choose phone type...</option>
                                <option value={1}>Mobile phone</option>
                                <option value={2}>Landline</option>
                            </Form.Control>
                            <small id="phoneNumberWarning" className="form-text text-danger" style={this.state.errors.phoneType != '' ? null : { "display": "none" }}><b>{this.state.errors.phoneType}</b></small>
                        </Form.Group>
                        <Alert variant="danger" style={this.state.errors.general != '' ? null : {"display": "none"}}>
                            {this.state.errors.general}
                        </Alert>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="default" onClick={this.props.hideModal}>Cancel</Button>
                    <Button bsStyle="primary" onClick={() => this.saveModel(this.state.user)}>Save</Button>
                </Modal.Footer>
            </>
        );
    }
}

export default CreateCustomerUserModal